import React, { useState } from 'react';
import { Pencil, Trash2 } from 'lucide-react';
import { useSalvaModulo, StatoModulo } from '../../utils/salvaModulo';
import { sipuoChiudere } from '../../utils/salvaCampo';
import MappaZone from './MappaZone';
import { visiteAPI } from '../../services/api';

/**
 * ModuloZone
 * Contenitore dello schema tecnico "zone trattate" dentro una
 * procedura. Segue lo schema che avevano ModuloBotox e ModuloFiller (tolti il
 * 22 settembre 2026):
 * il modulo salva, la mappa disegna.
 */
const ModuloZone = ({ modulo, visitaId, onUpdate, sessoPaziente }) => {
    const [editing, setEditing] = useState(false);
    const [contenuto, setContenuto] = useState(modulo.contenuto || { mappa: null, punti: [] });
    /* Lo schema si salva da solo (regola di Alex del 24/09/2026): quando un
       punto nasce o se ne va, quando cambia la tavola, e uscendo dal
       prodotto o dalla quantita'. Prima un errore di salvataggio finiva
       solo in console: adesso si vede, col motivo, e il punto resta. */
    const auto = useSalvaModulo(modulo);
    const chiudi = () => {
        if (!sipuoChiudere(auto.stato === 'in_corso', auto.stato === 'non_salvato' ? 1 : 0)) return;
        setEditing(false); if (onUpdate) onUpdate();
    };

    const handleDelete = async () => {
        if (!window.confirm('Eliminare questo schema?')) return;
        try {
            await visiteAPI.deleteModulo(modulo.id);
            if (onUpdate) onUpdate();
        } catch (e) {
            console.error('Errore eliminazione zone trattate:', e);
        }
    };

    return (
        <div className="modulo-box modulo-zone" data-salva-da-solo>
            <div className="modulo-header">
                <h3>{modulo.titolo || 'Zone trattate'}</h3>
                <div className="modulo-azioni">
                    {editing ? (
                        <>
                            <StatoModulo auto={auto} contenuto={contenuto} />
                            <button onClick={chiudi} className="btn-cancel" disabled={auto.stato === 'in_corso'}>Chiudi</button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setEditing(true)} className="btn-edit-small" title="Modifica">
                                <Pencil size={14} strokeWidth={1.8} aria-hidden="true" />
                            </button>
                            <button onClick={handleDelete} className="btn-delete-small" title="Elimina">
                                <Trash2 size={14} strokeWidth={1.8} aria-hidden="true" />
                            </button>
                        </>
                    )}
                </div>
            </div>

            <MappaZone
                data={contenuto}
                onChange={setContenuto}
                onFermo={auto.esci}
                readOnly={!editing}
                sessoPaziente={sessoPaziente}
            />
        </div>
    );
};

export default ModuloZone;
